import React from 'react';
import styled from 'styled-components';
import wirePropType from './prop-types';
import Ul from './common-styles';
import Like from './like';
import Comment from './comment';

const Ulist = styled.ul`
  ${Ul};

  & > li {
    span.count {
      display: block;
    }
    a {
      span {
        font-size: 30px;
      }
    }
  }
`;

export default function EngageGroup({ wire }) {
  return (
    <Ulist className="--engage">
      <li><Like wire={wire} /></li>
      <li><Comment wire={wire} fullWire /></li>
    </Ulist>
  );
}

EngageGroup.propTypes = wirePropType;
